import { DEFAULT_TENANT_ID_PREFIX } from 'client/constants'
import { getEnvironmentName } from 'shared/environment'

export const getTenantId = (_: string, region: string): string => {
  const environment = getEnvironmentName(process.env.NODE_ENV)

  return `${DEFAULT_TENANT_ID_PREFIX}-${region}-${environment}`.toUpperCase()
}
